import React, { useEffect, forwardRef, useState } from 'react'
import Utterance from './Utterance';

const ChatArea = forwardRef(({ pair, expand, onSaveClick, onGoodClick, onBadClick, onFeedbackClick, response, agents, pdfPathList, graphData, nextQuestions=[], showSpinner, errMsg}, ref) => {
  // expandがtrueなら
  const style = expand ? {} : { height: 'auto' };
  return (
    <div
      className="h-full mt-[5px] pt-[5px]"
      ref={ref}
      style={style}
    >
      {/* ユーザの発話 */}
      <Utterance
        utterance={pair[0]}
      />
      {/* アシスタントの発話 */}
      {pair[1] && <Utterance utterance={pair[1]} onSaveClick={onSaveClick} onGoodClick={onGoodClick} onBadClick={onBadClick} onFeedbackClick={onFeedbackClick} addMessage={response} agents={agents} addGraphs={graphData} pdfPathList={pdfPathList} nextQuestions={nextQuestions} showSpinner={showSpinner} errMsg={errMsg} />}
    </div>
  )
});

export default ChatArea